<ng-container *ngIf="_isLiftSuspensionAction; else suspendBlock">
    <p-dialog [(visible)]="displayModalSuspend" [modal]="true" [style]="{width: '500px'}"
              [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false"
              [closeOnEscape]="false" styleClass="suspend-customer-modal">
        <div class="flex flex-column">
            <h3 class="text-xl font-bold text-color m-0 mb-2">Lift suspension</h3>
            <p class="text-sm text-color-secondary line-height-3 m-0 mb-3">
                This will restore the account to Active.
            </p>
            <p class="font-semibold text-color m-0 mb-4">{{userName}} &bull; {{userId}}</p>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Select Reason:</label>
                <p-dropdown [options]="liftReasonOptions"
                            [(ngModel)]="selectedLiftReason"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Reason"
                            styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Notes (optional)</label>
                <textarea rows="3" pInputTextarea [(ngModel)]="liftNotes"
                          placeholder="Add internal notes that explain the context"
                          class="w-full"></textarea>
            </div>

            <div class="flex justify-content-center gap-3 mt-2 pt-2">
                <button pButton type="button" label="Cancel"
                        class="p-button-outlined p-button-secondary"
                        (click)="cancel()"></button>
                <button pButton type="button" label="Lift Suspension"
                        class="btn-teal"
                        [disabled]="!isLiftFormValid()"
                        (click)="liftSuspension()"></button>
            </div>
        </div>
    </p-dialog>
</ng-container>
<ng-template #suspendBlock>
    <p-dialog [(visible)]="displayModalSuspend" [modal]="true" [style]="{width: '500px'}"
              [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false"
              [closeOnEscape]="false" styleClass="suspend-customer-modal">
        <div class="flex flex-column">
            <h3 class="text-xl font-bold text-color m-0 mb-2">Suspend Customer</h3>
            <p class="text-sm text-color-secondary line-height-3 m-0 mb-3">
                Suspended customers cannot use Xpress services or wallet. Linked accounts are
                automatically unlinked.
            </p>
            <p class="font-semibold text-color m-0 mb-4">{{userName}} &bull; {{userId}}</p>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Select Reason:</label>
                <p-dropdown [options]="reasonOptions"
                            [(ngModel)]="selectedReason"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Reason"
                            styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Suspension Duration</label>
                <p-dropdown [options]="durationOptions"
                            [(ngModel)]="selectedDuration"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Duration"
                            styleClass="w-full">
                </p-dropdown>
            </div>

            <div class="mb-3">
                <label class="block text-sm font-semibold text-color mb-1">Additional details (optional)</label>
                <textarea rows="3" pInputTextarea [(ngModel)]="additionalDetails"
                          placeholder="Add internal notes that explain the context"
                          class="w-full"></textarea>
            </div>

            <div class="flex justify-content-center gap-3 mt-2 pt-2">
                <button pButton type="button" label="Cancel"
                        class="p-button-outlined p-button-secondary"
                        (click)="cancel()"></button>
                <button pButton type="button" label="Continue to Suspend"
                        class="p-button-danger suspend-btn-confirm"
                        [disabled]="!isFormValid()"
                        (click)="saveSuspend()"></button>
            </div>
        </div>
    </p-dialog>
</ng-template>
<p-toast></p-toast>
